export function setTransform(style: any, v: any) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

export function getPxStyle(value: number | string, unit = 'px', vertical: boolean = false) {
  value = vertical ? `0px, ${value}${unit}, 0px` : `${value}${unit}, 0px, 0px`;
  return `translate3d(${value})`;
}

const rect: any = {
  innerHeight: 0,
  innerWidth: 0,
};

export const UI = {
  scrollY() {
    const theScrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.body.scrollTop ||
      // @ts-ignore
      document.documentElement.scrollTop;
    return theScrollY;
  },

  offset(el: any, type?: string) {
    if (el) {
      const { left, top, width, height } = el.getBoundingClientRect();

      switch (type) {
        case 'top':
          return top + window.pageYOffset;

        case 'left':
          return left + window.pageXOffset;

        case 'height':
          return height;

        case 'width':
          return width;

        default:
          return {
            height,
            width,
            top: top + window.pageYOffset,
            left: left + window.pageXOffset,
            noEl: false,
          };
      }
    } else {
      return {
        height: 0,
        width: 0,
        top: 0,
        left: 0,
        noEl: true,
      };
    }
  },

  getFrame(el: any) {
    const { x = 0, y = 0, width = 0, height = 0 } = el ? el.getBoundingClientRect() : {};
    const dpr = window.devicePixelRatio;
    return { x: x / dpr, y: y / dpr, width: width / dpr, height: height / dpr };
  },

  isAxisYInViewport(el: any) {
    const { top, height } = UI.offset(el);
    const _scrollY = UI.scrollY();
    const _innerHeight = UI.innerHeight();

    // 卡片下半部分在视窗内
    if (top < _scrollY && top + height * 0.5 > _scrollY) {
      return 'bottom';
    }
    // 卡片上半部分在视窗内
    if (top + height * 0.5 < _scrollY + _innerHeight && top + height > _scrollY + _innerHeight) {
      return 'top';
    }
    // 理论上来说，计算可视区的时候应该算上tabBar，但是这样一来就耦合太深了，不好剔除，这里逻辑不做那么严格
    // 卡片超过50%内容进入视窗，认为是可视的
    if (
      (top >= _scrollY && top + height <= _scrollY + _innerHeight) ||
      // 卡片撑满了视窗还有多的
      (top <= _scrollY && top + height >= _scrollY + _innerHeight)
    ) {
      return 'all';
    }

    return 'none';
  },

  innerWidth() {
    rect.innerWidth = rect.innerWidth || window.innerWidth;
    return rect.innerWidth;
  },

  innerHeight() {
    rect.innerHeight = rect.innerHeight || window.innerHeight;
    return rect.innerHeight;
  },
};
